import { Injectable } from '@angular/core';
import {FirebaseApp} from "angularfire2";
import {CompEvent} from "../../models/CompEvent";
import 'firebase/storage';


/*
  Generated class for the MediaStorageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MediaStorageProvider {

  constructor(private firebase: FirebaseApp) {
  }

  uploadPhotoToStorage(storageRef: string, contentType: string, base64ImageString: string) : Promise<string> {

    return new Promise<any>((resolve, reject) => {
      let ref: any = this.firebase.storage().ref(storageRef);
      let uploadTask: any = ref.putString(base64ImageString, 'base64', { contentType: contentType });

      uploadTask.on('state_changed', snapshot => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');

        switch (snapshot.state) {
          case 'paused': // or 'paused'
            console.log('Upload is paused');
            break;
          case 'running': // or 'running'
            console.log('Upload is running');
            break;
        }
      }, (err) => {
        console.error('Error uploading image');
        console.error('Code is ' + err.code);
        reject('Error uploading photo: ' + err.code);
      }, () => {
        console.log('upload successful');
        resolve(uploadTask.snapshot.downloadURL);
      });
    });

  }

  static getStorageRefForEvent(event: CompEvent) : string {
    return `competitions/${event.competition.id}/${event.tourId}/${event.id}`;
  }

  static getStorageRefForUserProfilePhoto(userId, fileExtension: string) : string {
    return `users/profilePhotos/${userId}.${fileExtension}`;
  }

  static getStorageRefForGroup(groupId: string) : string {
    return `groups/${groupId}`
  }
}



// WEBPACK FOOTER //
// ./src/providers/media-storage/media-storage.ts